import { render, staticRenderFns } from "./rankPurchaseAmount.vue?vue&type=template&id=16979fac"
import script from "./rankPurchaseAmount.vue?vue&type=script&lang=js"
export * from "./rankPurchaseAmount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports